export default {
  items: (state) => state.items,
  itemsMeta: (state) => state.itemsMeta,
  itemsOption: (state) => state.itemsOption,
  itemsDetail: (state) => state.itemsDetail,
  itemsLoading: (state) => state.itemsLoading,
};
